import { Link } from 'react-router-dom';

const CtaSection = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Image Container */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-8 h-64 sm:h-80 lg:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/6b0aaaf4e8bd2a02bf26e2c89a8cc03b.jpg"
            alt="おかやま就労支援事業所の外観"
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* CTA Content */}
        <div className="text-center space-y-6 lg:space-y-8">
          <div className="space-y-3">
            <p className="text-xl sm:text-2xl lg:text-3xl font-serif text-text-dark leading-relaxed">
              まずは<strong>見学</strong>から。
            </p>
            <p className="text-xl sm:text-2xl lg:text-3xl font-serif text-text-dark leading-relaxed">
              <em className="font-medium">あなたのペース</em>で、一歩ずつ。
            </p>
            <p className="text-xl sm:text-2xl lg:text-3xl font-serif text-text-dark leading-relaxed">
              私たちがサポートします。
            </p>
          </div>

          <div className="pt-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-10 py-5 bg-text-dark text-white rounded-full font-bold text-base sm:text-lg hover:bg-primary transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-calendar-check-line mr-2 text-xl"></i>
              無料見学を予約する
            </Link>
          </div>

          <div className="pt-6 space-y-2">
            <p className="text-text-medium text-sm">お電話でのお問い合わせ</p>
            <a
              href="tel:0860123456"
              className="inline-flex items-center text-primary text-2xl sm:text-3xl font-bold hover:text-primary/70 transition-colors"
            >
              <i className="ri-phone-line mr-2"></i>
              086-012-3456
            </a>
            <p className="text-text-medium text-xs">受付時間: 9:00 - 18:00（日祝休）</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
